import { InjectionToken } from '@angular/core';
import { DashboardDefinition } from '../../../_shared/dashboard-definition.model';
import {
  Analysis,
  DashboardConfigurationDependencies,
  Granularity,
  Metric,
} from '../../../../dashboard-config/dashboard-config.model';
import { DashboardDataTransformer } from '../../../../data_transformers/dashboard_data_transformer';

export type RankingMultiColumnPopupSlot = 'economic_participants' | 'employed';

export interface RankingMultiColumnPopupView {
  kEur: boolean;
  slot?: RankingMultiColumnPopupSlot;
}

/** Chart / map column keys for the multi-column ranking matrix. */
export const RANKING_MC_VALUE_KEY = 'value';
export const RANKING_MC_VALUE_PCT_KEY = 'value_country_pct';
export const RANKING_MC_VALUE_SUM_KEY = 'value_sum';
export const RANKING_MC_VALUE_SUM_PCT_KEY = 'value_sum_pct';
export const RANKING_MC_VALUE_SUM_LABEL = 'Summe Teilmarkt';
export const RANKING_MC_RANK_KEY = 'rank';

export interface DashboardRankingMultiColumnView {
  valueKey: string;
  valuePctKey: string;
  valueSumKey: string;
  valueSumPctKey: string;
  valueSumLabel: string;
  rankKey: string;
  metricLabel: string;
  metricLabelKey?: string;
  analysisId: Analysis;
  metricId: Metric;
  granularityId: Granularity;
  popup: RankingMultiColumnPopupView;
}

export type DashboardRankingMultiColumnDefinition =
  DashboardDefinition<DashboardRankingMultiColumnView> & {
    mapHeading: (
      filterValues: Map<string, any>,
      product?: any,
      deps?: DashboardConfigurationDependencies,
    ) => string;
    exportTransformers: NonNullable<
      DashboardDefinition<DashboardRankingMultiColumnView>['exportTransformers']
    >;
    mapTransformers: (
      deps: DashboardConfigurationDependencies,
    ) => DashboardDataTransformer[];
  };

export const RANKING_MULTI_COLUMN_DEFINITION = new InjectionToken<DashboardRankingMultiColumnDefinition>('RANKING_MULTI_COLUMN_DEFINITION');
